import APIService from "./API.service";
const queryString = require("query-string");

class BadgeFormat extends APIService {
  // Get all badge formats
  getBadgeFormats(userId: number, start: number = 0, limit: number = 50) {
    const query = {
      start,
      limit,
      token: localStorage.getItem("fielddrive-token"),
    };

    return this.call.get(
      `${this.apiUrl}/badge_format/page/${userId}?${queryString.stringify(
        query
      )}`
    );
  }

  // Get a badge format by id
  getBadgeFormat(badgeFormatId: number) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.get(
      `${
        this.apiUrl
      }/badge_format/getById/${badgeFormatId}?${queryString.stringify(query)}`
    );
  }

  // Update a badge format
  updateBadgeFormat(badgeFormatId: number, body: any) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.put(
      `${this.apiUrl}/badge_format/${badgeFormatId}?${queryString.stringify(
        query
      )}`,
      JSON.stringify(body)
    );
  }

  // Create a badge format
  createBadgeFormat(body: any) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.post(
      `${this.apiUrl}/badge_format?${queryString.stringify(query)}`,
      JSON.stringify(body)
    );
  }

  // Delete a badge format by id
  deleteBadgeFormat(badgeFormatId: number) {
    const query = {
      token: localStorage.getItem("fielddrive-token"),
    };
    return this.call.delete(
      `${this.apiUrl}/badge_format/${badgeFormatId}?${queryString.stringify(
        query
      )}`
    );
  }
}

export default BadgeFormat;
